module.exports = __webpack_public_path__ + "assets/img/driver-btn-c236fe89.png";